import { getJSON } from "@/lib/api"

export type Textbook = {
  id: string
  title: string
  active: boolean
}

export type Chapter = {
  id: string
  number: number
  title: string
  description: string | null
  wordCount: number
  kanjiCount: number
  ruleCount: number
}

export const getTextbooks = () => getJSON<Textbook[]>("/v1/textbooks")
export const getChapters = (textbookId: string) =>
  getJSON<Chapter[]>(`/v1/textbooks/${textbookId}/chapters`)
